import { configureLocalization } from "@lit/localize";
import { TemplateMap } from "@lit/localize/internal/types";

import { sourceLocale, targetLocales } from "./codes";

export const { getLocale, setLocale } = configureLocalization({
	sourceLocale,
	targetLocales,
	loadLocale: () => {
		const templates = (self as any).__oz_localization_templates as TemplateMap;
		return Promise.resolve({ templates });
	},
});
